import SimpleNavigator from './SimpleNavigator';

customElements.define('cbp-simple-navigator', SimpleNavigator);
